import React from 'react';
import Moment from 'moment';

import { formatRatio, formatNumberWithDelimiter } from 'shared/number_helper';

export default class InterpretationBuilder {
    constructor(publication) {
        this.publication = publication;
    }

    get intro() {
        let intro = I18n.t('summary_tab.interpretation.intro');
        let html = [intro, this.journalFragment, this.citationsFragment].join(' ');
        return <p dangerouslySetInnerHTML={{ __html: html }} />;
    }

    get context() {
        let html = this.contextFragment;
        return <p dangerouslySetInnerHTML={{ __html: html }} />;
    }

    get contextFragment() {
        let fcr = this.publication.fieldCitationRatio;
        if (fcr >= 5) {
            return I18n.t('summary_tab.interpretation.fcr.very_high', { ratio: formatRatio(fcr) });
        } else if (fcr >= 1.2) {
            return I18n.t('summary_tab.interpretation.fcr.high', { ratio: formatRatio(fcr) });
        } else if (fcr >= 0.8) {
            return I18n.t('summary_tab.interpretation.fcr.average');
        } else if (fcr > 0) {
            let percentage = Math.floor(fcr * 100);
            return I18n.t('summary_tab.interpretation.fcr.low', { ratioPercentage: percentage });
        } else if (this.yearsOld <= 2 && this.publication.totalCitations > 0) {
            return I18n.t('summary_tab.interpretation.fcr.na_new');
        } else {
            return I18n.t('summary_tab.interpretation.fcr.na_other');
        }
    }

    get journalFragment() {
        if (!this.publication.journal) return '';

        return I18n.t('summary_tab.interpretation.journal', { name: this.publication.journal.title });
    }

    get citationsFragment() {
        if (this.publication.totalCitations > 0) {
            let text = I18n.t('summary_tab.interpretation.citations', {
                count: this.publication.totalCitations,
                formattedCount: formatNumberWithDelimiter(this.publication.totalCitations)
            });
            return [text, this.recencyFragment].join(' ');
        } else {
            let text = I18n.t('summary_tab.interpretation.no_citations');
            return [text, this.explainNoCitationsFragment].join(' ');
        }
    }

    get recencyFragment() {
        let yearsOld = this.yearsOld;
        let hasAnyRecentCitations = this.publication.recentCitations != 0;

        if (yearsOld < 2 || !hasAnyRecentCitations) return '';

        let percentRecent = Math.floor((this.publication.recentCitations / this.publication.totalCitations) * 100);
        let baseText = I18n.t('summary_tab.interpretation.recency', { percentage: percentRecent });

        let hasHighActivity = percentRecent > (100 / yearsOld) * 1.5 && this.publication.totalCitations >= 10;

        if (hasHighActivity) {
            let highActivityText = I18n.t('summary_tab.interpretation.high_recency');
            return `${baseText}, ${highActivityText}.`;
        } else {
            return `${baseText}.`;
        }
    }

    get explainNoCitationsFragment() {
        let date = this.publication.publicationDate;
        if (!date) return;

        if (date.year() <= 1997) {
            return I18n.t('summary_tab.interpretation.older_paper');
        } else if (date.year() == Moment().year()) {
            return I18n.t('summary_tab.interpretation.current_paper');
        } else {
            return '';
        }
    }

    get yearsOld() {
        return this.publication.publicationDate ? Moment().diff(this.publication.publicationDate, 'years') : 0;
    }
}
